/**
 * Following a job on the server until it ends: the asking that every kind of job shares.
 */

import type { TheoryJob } from "@app/shared-types";

/** How often a running job is asked how far it has got. */
const POLL_MS = 750;

/** What a failure said, as words for the page. */
export function said(cause: unknown): string {
  return cause instanceof Error ? cause.message : String(cause);
}

/**
 * Ask after a job until it is no longer running, telling `told` each progress it reports.
 *
 * Resolves with what the job made; with `null` when it was cancelled, or when `live` says
 * the page has stopped waiting for it. Rejects with the job's own words when it failed.
 */
export async function followed<Progress, Result>(
  ask: () => Promise<TheoryJob<Progress, Result>>,
  live: () => boolean,
  told: (progress: Progress) => void,
): Promise<Result | null> {
  const found = await ask();
  if (!live()) return null;
  if (found.state === "running") {
    told(found.progress);
    await new Promise<void>((resolve) => window.setTimeout(resolve, POLL_MS));
    return live() ? followed(ask, live, told) : null;
  }
  if (found.state === "failed") throw new Error(found.error?.message ?? "the run failed");
  return found.result ?? null;
}
